import React from 'react'

const CfLoader = () => {
  return (
    <div className=" w-20 h-20 border-b-gray-150 border-r-gray-150 border-t-cfPrimary border-l-cfPrimary border-8 rounded-full self-center animate-spin"/>
  )
}

export default CfLoader